<template>
    <div>

        <div class="layui-card-header">
            <blockquote class="layui-elem-quote">
                认定缴费
            </blockquote>
        </div>

        <div class="layui-card-body">

            <el-table :data="tableData" style="width: 100%">
                <!-- 序号 -->
                <el-table-column align="center" label="序号" width="50" type="index">
                </el-table-column>
                <!-- 申报状态 -->
                <el-table-column align="center" label="申报状态" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.declareStatus == 1" style="color: red;">待申报</span>
                        <span v-if="scope.row.declareStatus == 2" style="color: green;">开始申报</span>
                    </template>
                </el-table-column>


                <!-- 报名状态 -->
                <el-table-column align="center" label="报名状态" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.registrationreStatus == 1" style="color: green;">正常</span>
                        <span v-if="scope.row.registrationreStatus == 2" style="color: red;">预报名</span>
                    </template>
                </el-table-column>

                <!-- 申报工种  -->
                <el-table-column align="center" label="申报工种" width="180" prop="workTypeAlias">
                </el-table-column>

                <!-- 申报等级  -->
                <el-table-column align="center" label="申报等级" width="180" prop="workTypeLevelStateDesc">
                </el-table-column>

                <!-- 申报时间  -->
                <el-table-column align="center" label="申报时间" width="180" prop="declareTime">
                </el-table-column>


                <!-- 审核状态 -->
                <el-table-column align="center" label="审核状态" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.examineStatus == 1" style="color: #00aeef;">审核中</span>
                        <span v-if="scope.row.examineStatus == 2" style="color: #49af4a;">通过</span>
                        <span v-if="scope.row.examineStatus == 3" style="color: red;">未通过</span>
                    </template>
                </el-table-column>


                <!-- 缴费形式 -->
                <el-table-column align="center" label="缴费形式" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pay_type == 1">个人缴费</span>
                        <span v-if="scope.row.pay_type == 2">单位缴费</span>
                        <span v-if="scope.row.pay_type == null">未知</span>
                    </template>
                </el-table-column>

                <!-- 缴费类型 -->
                <el-table-column align="center" label="缴费类型" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.order_grade == 1">认定</span>
                        <span v-if="scope.row.order_grade == 2">认定+培训+练习</span>
                        <span v-if="scope.row.order_grade == null">未选择</span>
                    </template>
                </el-table-column>


                <!-- 缴费状态 -->
                <el-table-column align="center" label="缴费状态" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.order_status == 1 || scope.row.order_status == null"
                            style="color: red;">待缴费</span>
                        <span v-if="scope.row.order_status == 2" style='color: #49af4a;'>支付成功</span>
                        <span v-if="scope.row.order_status == 3" style='color: darkgray;'>订单已过期</span>
                        <!-- <span v-else="" style='color: red;'>待缴费</span> -->
                    </template>
                </el-table-column>

                <!-- 已缴纳(元) -->
                <el-table-column align="center" label="已缴纳(元)" width="120" prop="declareAmount">
                </el-table-column>

                <!-- 缴费时间 -->
                <el-table-column align="center" label="缴费时间" width="150" prop="orderPayTime">
                </el-table-column>


                <el-table-column align="center" label="操作" fixed="right" width="270">
                    <template slot-scope="scope">

                        <el-button
                            v-if="scope.row.examineStatus == 2 && scope.row.order_status == 1 && scope.row.registrationreStatus ==1"
                            size="mini" type="primary" @click="ImmediatePayment(scope.row)">立即缴费</el-button>

                        <el-button
                            v-if="scope.row.examineStatus == 2 && scope.row.order_status == 1 && scope.row.registrationreStatus ==2"
                            size="mini" type="primary" disabled>预报名</el-button>

                        <el-button v-if="scope.row.examineStatus == 2 && scope.row.order_status == 2" size="mini"
                            type="primary" disabled>已缴费</el-button>

                        <el-button
                            v-if="scope.row.examineStatus == 2 && scope.row.order_status != 2 && scope.row.order_status != 1 && scope.row.registrationreStatus == 1"
                            size="mini" type="primary" @click="ImmediatePayment(scope.row)">立即缴费</el-button>

                        <el-button
                            v-if="scope.row.examineStatus == 2 && scope.row.order_status != 2 && scope.row.order_status != 1 && scope.row.registrationreStatus == 2"
                            size="mini" type="primary" disabled>预报名</el-button>

                        <el-button v-if="scope.row.examineStatus == 3" size="mini" type="primary" disabled>无</el-button>

                        <el-button v-if="scope.row.examineStatus == 1" size="mini" type="primary" disabled>立即缴费
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog :title='nameOfPayingJob' :visible.sync="dialogTableVisible2" :center="true" width="40%">
                <div style="position: relative;">
                    <div id="ddBox" style="display: flex;">
                        <div class="open_left">
                            <span style="font-weight: 600">服务类型</span>
                        </div>
                        <div class="open_right">
                            <div class="layui-form-item">
                                <div class="layui-input-block" style="margin-left: 0px">
                                    <div class="layui-unselect layui-form-radio layui-form-radioed"><i
                                            class="layui-anim layui-icon" style="color: #5FB878;"></i>
                                        <div>认定</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="order_bottom">
                            <div class="allPrice">
                                <span class="" style="color: #999">总金额：</span><span
                                    class="allPrice_span">{{firmlyBelieveCost}}</span>
                            </div>
                            <div class="zhifu">
                                <button id="toBuy" @click="immediatePay">立即支付</button>
                            </div>
                        </div>

                    </div>
                </div>
            </el-dialog>

            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>


        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        compoents: {

        },
        data() {
            return {
                state: 0,
                dialogTableVisible2: false,
                nameOfPayingJob: '123456',
                total: 0,   //一共多少条
                pagesize: 2,  //一页几条
                currentPage: 1,//当前页
                tableData: [],
                orderId: 0,
                firmlyBelieveCost: 0,
                declareUserId: 0 //当前点击数据申报表id
            }
        },
        created() {
            this.state = this.$route.params.state;
            this.loadData(this.currentPage, this.pagesize);
        },
        mounted() {

        },
        methods: {
            //立即支付
            immediatePay() {
                console.log(this.orderId);
                // 先去后台创建订单
                let parames = new URLSearchParams();
                parames.append('id', this.orderId);
                parames.append('order_amount', this.firmlyBelieveCost);
                parames.append('userId', this.$storage.get('declareUser').id);
                parames.append('declareUserId', this.declareUserId);
                parames.append('order_grade', 1); //缴费等级  普通 1/精品 2
                parames.append('order_commodityName', this.getWorkTypeLevelStateDesc(parseInt(this.$route.params.workTypeLevelState)) + '-' + this.nameOfPayingJob);

                let urlStr = '';
                //判断是否为 综改区
                if (this.state == 1) {
                    urlStr = '/addOrderRecord';
                } else {
                    urlStr = '/addOrderRecord_zg';
                }

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + urlStr, parames).then(resp => {
                    if (resp.data.code === 1) {
                        console.log("成功返回订单id========" + resp.data.orderId);
                        const { href } = this.$router.resolve({
                            name: "affirmPay",
                            params: { orderId: resp.data.orderId, state: this.state }
                        });
                        window.open(href, '_blank');

                        let _this = this;
                        this.$confirm('确认支付完毕?', '提示', {
                            cancelButtonText: '取消',
                            confirmButtonText: '确定',
                            type: 'warning'
                        }).then(() => {
                            _this.dialogTableVisible2 = false;
                            _this.loadData(_this.currentPage, _this.pagesize);
                        }).catch(() => {
                            this.dialogTableVisible2 = false;
                            _this.loadData(_this.currentPage, _this.pagesize);
                        });

                    } else {
                        this.$message({
                            showClose: true,
                            message: '服务器繁忙，稍后重试！',
                            type: 'error'
                        });
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            },
            //立即缴费
            ImmediatePayment(row) {
                this.declareUserId = row.id;
                this.orderId = row.orderId;
                this.nameOfPayingJob = row.workTypeAlias;


                //获取认定费用
                let parames = new URLSearchParams();
                parames.append('workTypeId', row.workTypeId);
                parames.append('workTypeLevelState', this.$route.params.workTypeLevelState);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/selectOrderVip', parames).then(resp => {
                    if (resp.data.code === 1) {
                        if (row.declareClassification === '初次鉴定') {
                            this.firmlyBelieveCost = resp.data.data.fristPrice;
                        } else if (row.declareClassification === '晋级鉴定') {
                            this.firmlyBelieveCost = resp.data.data.secendPrice;
                        } else if (row.declareClassification === '补考鉴定') {
                            this.firmlyBelieveCost = resp.data.data.makeUpPrice;
                        }

                        this.dialogTableVisible2 = true;
                    } else {
                        this.$message({
                            showClose: true,
                            message: '服务器繁忙，稍后重试！',
                            type: 'error'
                        });
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            },
            //切换每页多少条 触发
            handleSizeChange(val) {
                console.log(`每页dusoaho条`);
                this.pagesize = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            //第几页切换的时 触发
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            getWorkTypeLevelStateDesc(level) {
                var workTypeLevelStateDesc = '';
                switch (level) {
                    case 1:
                        workTypeLevelStateDesc = "高级技师";
                        break; //可选
                    case 2:
                        //语句
                        workTypeLevelStateDesc = "技师";
                        break; //可选
                    case 3:
                        //语句
                        workTypeLevelStateDesc = "三级（高级工）";
                        break; //可选
                    case 4:
                        //语句
                        workTypeLevelStateDesc = "四级（中级工）";
                        break; //可选
                    default: //可选
                        //语句
                        workTypeLevelStateDesc = "五级（初级工）";
                }
                return workTypeLevelStateDesc;
            },
            loadData(page, limit) {
                let parames = new URLSearchParams();

                console.log("======"+this.$route.params.workTypeLevelState)


                console.log("=============="+this.$storage.get('declareUser').id)
                parames.append('levelState', this.$route.params.workTypeLevelState);
                //parames.append('order_status', 1);
                parames.append('examineStatus', 2);
                parames.append('userId', this.$storage.get('declareUser').id);
                parames.append('page', page);
                parames.append('limit', limit);


                if (this.state == 2) {
                    parames.append('declareCode', this.declareCode);
                }
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/getDeclareUserOccupation_v1', parames).then(resp => {
                    this.total = resp.data.count;
                    console.log("============="+this.total)
                    if (resp.data.code === 1) {
                        let ArrayList = [];
                        resp.data.data.forEach(element => {
                            let UserDeclareOccupationData = {
                                id: '',//申报主表id
                                workTypeAlias: '',//申报工种名称
                                workTypeLevelState: 0,//申报等级
                                workTypeLevelStateDesc: '',
                                registrationreStatus: 0,
                                workTypeId: 0,
                                scienceSumNum: 0,//当前工种申报等级所需上传认定条件资料总量
                                scienceNum: 0,  //当前工种申报等级下的材料数量-每种条件只能上传一份材料
                                declareStatus: 0,////申报状态  1确定申报  2取消申报  3.申报中 2020年10月23日09:19:08  liqi  新增申报中状态
                                insertTime: '',//资料填写时间
                                declareTime: '',
                                examineStatus: 0,
                                pay_type: 0,
                                order_grade: 0,
                                order_status: 0,
                                declareAmount: '',
                                orderPayTime: '',
                                orderId: 0,
                                declareClassification: ''
                            };
                            UserDeclareOccupationData.id = element.id;
                            UserDeclareOccupationData.workTypeAlias = element.workTypeAlias;
                            UserDeclareOccupationData.workTypeLevelState = element.workTypeLevelState;
                            UserDeclareOccupationData.workTypeLevelStateDesc = this.getWorkTypeLevelStateDesc(element.workTypeLevelState);
                            UserDeclareOccupationData.declareStatus = element.declareStatus;
                            UserDeclareOccupationData.registrationreStatus = element.registrationreStatus;  //报名状态
                            UserDeclareOccupationData.declareTime = element.declareTime.substring(0, 10); //申报时间
                            UserDeclareOccupationData.examineStatus = element.examineStatus;//审核状态
                            UserDeclareOccupationData.pay_type = element.pay_type; ////缴费类型 1.个人付费2.单位付费
                            UserDeclareOccupationData.order_grade = element.order_grade;

                            UserDeclareOccupationData.order_status = element.order_status;

                            if (element.declareAmount == null) {
                                UserDeclareOccupationData.declareAmount = '0.00';
                            } else {
                                UserDeclareOccupationData.declareAmount = element.declareAmount;
                            }

                            if (element.orderPayTime != null) {
                                UserDeclareOccupationData.orderPayTime = element.orderPayTime.substring(0, 10);
                            } else {
                                UserDeclareOccupationData.orderPayTime = '暂无';
                            }

                            UserDeclareOccupationData.workTypeId = element.workTypeId;

                            if (element.orderId != null) {
                                UserDeclareOccupationData.orderId = element.orderId;
                            }

                            UserDeclareOccupationData.declareClassification = element.declareClassification;

                            UserDeclareOccupationData.insertTime = element.insertTime.substring(0, 10);
                            ArrayList.push(UserDeclareOccupationData);
                        });
                        this.tableData = ArrayList;
                    }
                }).catch(err => {
                    console.log(err);
                })
            },
            handleEdit(index, row) {
                console.log(index, row);
            },
            handleDelete(index, row) {
                console.log(index, row);
            }
        }

    }
</script>

<style scoped>
    .el-table__empty-block {
        min-height: 60px;
        text-align: center;
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .el-dialog {
        position: relative;
        margin: 0 auto 50px;
        border-radius: 2px;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
        box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 80%;
        /* height: 650px; */
        /* overflow: scroll; */
        margin-top: 20vh !important;
    }

    .el-dialog--center .el-dialog__body {
        text-align: initial;
        /* padding: 25px 25px 30px; */
    }

    .el-dialog__body {
        padding: 0 !important;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }


    #toBuy {
        width: 140px;
        line-height: 38px;
        color: #fff;
        font-size: 16px;
        border-radius: 2px;
        background: #5FB878;
        border: none;
        cursor: pointer;
    }

    .zhifu {
        float: right;
        margin-top: 22px;
        margin-right: 23px;
    }

    .allPrice {
        float: left;
        font-size: 18px;
        color: red;
        margin-top: 27px;
        margin-left: 40px;
    }

    .order_bottom {
        width: 100%;
        height: 79px;
        background-color: white;
        position: absolute;
        bottom: 0px;
        left: 0;
        box-shadow: 0px 2px 6px #ccc;
    }

    .open_right {
        width: 500px;
        margin-top: 31px;
        float: left;
    }

    #ddBox {
        padding-left: 24px;
        padding-right: 24px;
        padding-bottom: 80px;
        height: 226px;
        overflow-y: auto;
    }

    .open_left {
        float: left;
        margin-top: 19px;
        width: 115px;
        line-height: 60px;
        text-align: right;
        font-size: 14px;
        color: #000000;
        padding-right: 28px;
        box-sizing: border-box;
    }

    .el-radio__input.is-checked+.el-radio__label {
        color: #5FB878;
    }

    .el-radio__input.is-checked .el-radio__inner {
        border-color: #5FB878;
        background: #5FB878;
    }

    select {
        display: none;
    }

    .layui-edge {
        display: inline-block;
        width: 0;
        height: 0;
        border-width: 6px;
        border-style: dashed;
        border-color: transparent;
    }

    .layui-form-select .layui-edge {
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -3px;
        cursor: pointer;
        border-width: 6px;
        border-top-color: #c2c2c2;
        border-top-style: solid;
        transition: all .3s;
        -webkit-transition: all .3s;
    }

    .layui-form-select dl dd,
    .layui-form-select dl dt {
        padding: 0 10px;
        line-height: 36px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .layui-form-select dl dd {
        cursor: pointer;
    }

    .layui-form-select dl dd.layui-this {
        background-color: #5FB878;
        color: #fff;
    }

    .layui-form-select dl dd.layui-select-tips {
        padding-left: 10px !important;
        color: #999;
    }

    dl {
        display: none;
        position: absolute;
        left: 0;
        top: 42px;
        padding: 5px 0;
        z-index: 899;
        min-width: 100%;
        border: 1px solid #d2d2d2;
        max-height: 300px;
        overflow-y: auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
        box-sizing: border-box;
    }

    .layui-input,
    .layui-textarea {
        display: block;
        width: 100%;
        padding-left: 10px;
        height: 38px;
        line-height: 1.3;
        line-height: 38px\9;
        border-width: 1px;
        border-style: solid;
        background-color: #fff;
        border-radius: 2px;
    }

    .layui-form-select .layui-input {
        padding-right: 30px;
        cursor: pointer;
    }

    .layui-form-label,
    .layui-form-mid,
    .layui-form-select,
    .layui-input-block,
    .layui-input-inline,
    .layui-textarea {
        position: relative;
    }

    .layui-input-inline {
        display: inline-block;
        vertical-align: middle;
    }

    button,
    input,
    optgroup,
    option,
    select,
    textarea {
        font-family: inherit;
        font-size: inherit;
        font-style: inherit;
        font-weight: inherit;
        outline: 0;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .layui-btn-normal {
        background-color: #1E9FFF;
    }

    .layui-btn-sm {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        font-size: 12px;
    }

    .layui-anim.layui-icon {
        display: inline-block;
    }

    .layui-form-radio>i {
        margin-right: 8px;
        font-size: 22px;
        color: #c2c2c2;
    }

    .layui-form-radio {
        display: inline-block;
        vertical-align: middle;
        line-height: 28px;
        margin: 6px 10px 0 0;
        padding-right: 10px;
        cursor: pointer;
        font-size: 0;
    }

    .layui-input-block {
        margin-left: 110px;
        min-height: 36px;
    }

    .ux-input_base {
        padding: .16rem .32rem;
        font-size: 14px;
        border: 1px solid #ddd;
        color: #555;
        background: #fff;
        border-radius: 2px;
        vertical-align: middle;
    }

    .ux-input2,
    .ux-textarea2 {
        display: inline-block;
        position: relative;
        white-space: nowrap;
    }

    .userInfo .layui-icon-tips {
        font-size: 13px;
    }

    .layui-show {
        display: block !important;
    }

    .layui-upload-drag .layui-icon {
        font-size: 50px;
        color: #009688;
    }

    .layui-upload-file {
        display: none !important;
        opacity: .01;
        filter: Alpha(opacity=1);
    }

    .layui-upload-drag {
        position: relative;
        padding: 30px;
        border: 1px dashed #e2e2e2;
        background-color: #fff;
        text-align: center;
        cursor: pointer;
        color: #999;
    }

    .layui-upload-drag {
        border: 1px solid #5fb878;
    }

    .layui-icon {
        font-family: layui-icon !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .userInfo .layui-icon-tips {
        font-size: 13px;
    }

    .input-row-right input[type="text"] {
        width: 400px;
        height: 30px;
    }

    .ux-input2,
    .ux-textarea2 {
        display: inline-block;
        position: relative;
        white-space: nowrap;
    }

    .profile-image-upload {
        text-align: center;
        position: relative;
        vertical-align: top;
        display: inline-block;
        border-radius: 50%;
        width: 104px;
        height: 104px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url(/jnrd/img/profile-image.png);
    }

    .input-row-right {
        font-size: 12px;
        width: 690px;
        text-align: left;
        display: inline-block;
        vertical-align: top;
        text-align: left;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .input-row-left {
        width: 100px;
        text-align: left;
        padding-left: 50px;
        display: inline-block;
        vertical-align: top;
        text-align: left;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .f-cb:after {
        display: block;
        clear: both;
        visibility: hidden;
        height: 0;
        overflow: hidden;
        content: ".";
    }

    .layui-card-body {
        position: relative;
        padding: 10px 15px;
        line-height: 24px;
    }

    .layui-card-header {
        position: relative;
        height: 42px;
        line-height: 42px;
        padding: 0 15px;
        border-bottom: 1px solid #f6f6f6;
        color: #333;
        border-radius: 2px 2px 0 0;
        font-size: 14px;
    }

    .u-gx-ttop {
        border-bottom: none;
        margin: 0 15px;
        height: 38px;
        padding: 10px 0;
    }

    .f-fc9 {
        color: #999;
    }

    .f-f0 {
        font-family: "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
    }

    .f-fl {
        float: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/affirm/affirmPayTheFees.vue